var _defs, _rect, _path, _rect2, _circle, _rect3, _rect4, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNamaz1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Namaz-1_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 143.5 102.5"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Namaz-1_svg__cls-1,.Namaz-1_svg__cls-2{fill:#fdb515;stroke:#c4820e;stroke-miterlimit:10}.Namaz-1_svg__cls-2{fill:none;stroke-width:.5px}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "Namaz-1_svg__cls-1",
    x: 125.5,
    y: 26,
    width: 17.5,
    height: 76,
    rx: 8.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-1",
    transform: "rotate(-90 53.935 119.065)",
    d: "M135.62 122.37h13.75v13.75h-13.75z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "Namaz-1_svg__cls-1",
    x: 164.12,
    y: 92.25,
    width: 40.5,
    height: 74,
    rx: 20.25,
    transform: "rotate(-90 95.81 119.06)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "Namaz-1_svg__cls-1",
    cx: 30.75,
    cy: 30.5,
    r: 30
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "Namaz-1_svg__cls-1",
    x: 160.04,
    y: 116.1,
    width: 16.01,
    height: 43.7,
    rx: 8.01,
    transform: "rotate(-45 9.656 183.18)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "Namaz-1_svg__cls-1",
    x: 185.71,
    y: 141.77,
    width: 16.01,
    height: 43.7,
    rx: 8.01,
    transform: "rotate(135 174.977 98.012)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 158.5s-8.21-.74-10.32-1.36c-14.58-4.32-15.74-20.94-2.21-26.41 2.26-.92 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 157.75s-8.21-.73-10.32-1.36c-14.58-4.31-15.74-20.93-2.21-26.39 2.26-.91 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 156.89s-8.21-.74-10.32-1.37c-14.58-4.31-15.74-20.93-2.21-26.41 2.26-.91 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 156s-8.21-.74-10.32-1.36c-14.58-4.32-15.74-20.94-2.21-26.42 2.26-.91 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 155.15s-8.21-.74-10.32-1.36c-14.58-4.32-15.74-20.94-2.21-26.42 2.26-.91 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 154s-8.21-.74-10.32-1.36c-14.58-4.32-15.74-20.94-2.21-26.42 2.26-.91 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 152.91s-8.21-.74-10.32-1.36c-14.58-4.31-15.74-20.94-2.21-26.41 2.26-.92 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 151.79s-8.21-.73-10.32-1.36C75.73 146.12 74.57 129.5 88.1 124c2.26-.92 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 151.05s-8.21-.74-10.32-1.36c-14.58-4.32-15.74-20.94-2.21-26.42 2.26-.91 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 149.93s-8.21-.74-10.32-1.36c-14.58-4.32-15.74-20.94-2.21-26.41 2.26-.92 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 148.94s-8.21-.74-10.32-1.36c-14.58-4.32-15.74-20.94-2.21-26.42 2.26-.91 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 148.07s-8.21-.74-10.32-1.36c-14.58-4.32-15.74-20.94-2.21-26.42 2.26-.91 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 147.32s-8.21-.74-10.32-1.36c-14.58-4.31-15.74-20.96-2.21-26.41 2.26-.92 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 146.58s-8.21-.74-10.32-1.36c-14.58-4.32-15.74-20.94-2.21-26.42 2.26-.91 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 145.46s-8.21-.74-10.32-1.36c-14.58-4.32-15.74-20.94-2.21-26.42 2.26-.91 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 144.71s-8.21-.73-10.32-1.36c-14.58-4.35-15.74-20.93-2.21-26.41 2.26-.92 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 143.6s-8.21-.74-10.32-1.37c-14.58-4.31-15.74-20.93-2.21-26.41 2.26-.91 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 142.85s-8.21-.74-10.32-1.36c-14.58-4.32-15.74-20.94-2.21-26.41 2.26-.92 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 142s-8.21-.74-10.32-1.36c-14.58-4.31-15.74-20.94-2.21-26.41 2.26-.92 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 141.11s-8.21-.74-10.32-1.36c-14.58-4.31-15.74-20.93-2.21-26.41 2.26-.92 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 140.24s-8.21-.73-10.32-1.36c-14.58-4.31-15.74-20.88-2.21-26.41 2.26-.92 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 139.12s-8.21-.73-10.32-1.36c-14.58-4.31-15.74-20.93-2.21-26.41 2.26-.91 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 138s-8.21-.74-10.32-1.36c-14.58-4.32-15.74-20.94-2.21-26.42 2.26-.91 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 137.26s-8.21-.74-10.32-1.36c-14.58-4.31-15.74-20.9-2.21-26.41 2.26-.92 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 136.14s-8.21-.73-10.32-1.36c-14.58-4.31-15.74-20.93-2.21-26.41 2.26-.92 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 135s-8.21-.74-10.32-1.37c-14.58-4.31-15.74-20.93-2.21-26.41 2.26-.91 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 134s-8.21-.73-10.32-1.36c-14.58-4.31-15.74-20.93-2.21-26.41 2.26-.92 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 133.16s-8.21-.73-10.32-1.36c-14.58-4.31-15.74-20.93-2.21-26.41 2.26-.92 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 132.42s-8.21-.74-10.32-1.36c-14.58-4.32-15.74-20.94-2.21-26.42 2.26-.91 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 131.67s-8.21-.73-10.32-1.36C75.73 126 74.57 109.38 88.1 103.9c2.26-.92 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 130.55s-8.21-.73-10.32-1.36c-14.58-4.31-15.74-20.93-2.21-26.41 2.26-.91 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 129.81s-8.21-.74-10.32-1.36c-14.58-4.32-15.74-20.94-2.21-26.45 2.26-.91 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "Namaz-1_svg__cls-2",
    d: "M100.63 129.81s-8.21-.74-10.32-1.36c-14.58-4.32-15.74-20.94-2.21-26.45 2.26-.91 12.53-2 12.53-2z",
    transform: "translate(-78.38 -98.75)"
  })));
}

export default SvgNamaz1;